import {
    type PayloadAction,
    createSlice,
    createSelector,
} from '@reduxjs/toolkit';
import { mtanFieldName } from '@dekafvv/sharedfrontend';
import { RootState } from 'store';
import { passwordFieldNames } from 'shared/password';

export const passwordStepNames = {
    passwordFields: 'passwordFields',
    mtan: 'mtan',
    success: 'success',
} as const;

export type PasswordValues = {
    [passwordFieldNames.password]: string;
    [passwordFieldNames.confirmPassword]: string;
}

type PasswordMtan = {
    [mtanFieldName]: string
}

type InitialPasswordSlice = {
    answers: {
        [passwordStepNames.passwordFields]: PasswordValues,
        [passwordStepNames.mtan]: PasswordMtan
    }
}

const initialPasswordState: InitialPasswordSlice = {
    answers: {
        [passwordStepNames.passwordFields]:
        {
            [passwordFieldNames.password]: '',
            [passwordFieldNames.confirmPassword]: '',
        },
        mtan: {
            [mtanFieldName]: '',
        },
    },

};

export const passwordSlice = createSlice({
    name: 'password',
    initialState: initialPasswordState,
    reducers: {
        setPasswordAnswers: (
            state,
            action: PayloadAction<{ [stepName: string]: PasswordValues }>,
        ) => ({
            ...state,
            answers: {
                ...state.answers,
                ...action.payload,
            },
        }),
        clearPasswordState: (state) => ({
            ...state,
            ...initialPasswordState,
        }),
    },
});

export const selectPassword = (state: RootState) => state.password;

export const selectPasswordValues = createSelector(
    selectPassword,
    (password: InitialPasswordSlice) => password.answers[passwordStepNames.passwordFields],
);

export const {
    clearPasswordState,
    setPasswordAnswers,
} = passwordSlice.actions;
